
import Autocomplete, {Config} from "bootstrap5-autocomplete";
import "~/globals";

const URL_COMUNENASCITA = window.BaseUrlWebApi + "Istat/GetComuneNascita";
const URL_COMUNERESIDENZA = window.BaseUrlWebApi + "Istat/GetComuneResidenza";

// Funzione interna per effettuare il fetch dei dati
const fetchAutocompleteData = async (url: string, searchValue: string) => {
    try {
        const response = await fetch(`${url}?search=${encodeURIComponent(searchValue)}`);
        if (!response.ok) throw new Error('Errore nella ricerca');
        return await response.json();
    } catch (error) {
        console.error('Errore durante il fetch dei dati:', error);
        return [];
    }
};

// Funzione esportata per impostare il valore nell'autocomplete
export const setAutocompleteValue = async (elementId: string, value: string) => {
    const $element = $("#" + elementId);
    const setter = $element.data('autocomplete-setter');

    if (typeof setter === 'function') {
        await setter(value);
        return true;
    } else {
        console.warn(`Nessun setter trovato per l'elemento con ID: ${elementId}`);
        return false;
    }
};


export const autoCompleteComuni =
    (nascita: boolean,
     elementId: string,
     hiddenElementId: string,
     provinciaElementId: string | null,
     provinciaTextElementId: string | null,
     capElementId: string | null,
     placeholder?: string,
     LoadCallBack?: () => void,
     SelectCallBack?: (item: any) => void,)=> {

        let url = nascita ? URL_COMUNENASCITA : URL_COMUNERESIDENZA;
        const resetFields = function () {
            $("#" + hiddenElementId).val("");
            if (provinciaElementId != undefined)
                $("#" + provinciaElementId).val("");
            if (provinciaTextElementId != undefined)
                $("#" + provinciaTextElementId).val("");
            if (capElementId != undefined)
                $("#" + capElementId).val("");
            if (LoadCallBack != undefined)
                LoadCallBack();
        };

        const onSelectItem = function (item:any) {
            if (hiddenElementId != undefined)
                $("#" + hiddenElementId)
                    .val(item.IdComune)
                    .data("select-item", item); //userò codice catastale per validazione CF (Profilo.ts)

            const event = new Event("change", { bubbles: true });
            const hiddenEl = $("#" + hiddenElementId)[0];
            if (!hiddenEl) {
                console.warn(`Elemento con id '${hiddenElementId}' non trovato per dispatchEvent`);
            } else {
                hiddenEl.dispatchEvent(event);
            }
            //$("#" + hiddenElementId)[0].dispatchEvent(event);


            if (provinciaElementId != undefined)
                $("#" + provinciaElementId).val(item.IdProvincia);
            if (capElementId != undefined)
                $("#" + capElementId).val(item.Cap);
            if (provinciaTextElementId != undefined)
                $("#" + provinciaTextElementId).val(item.Provincia);
            if (SelectCallBack != undefined)
                SelectCallBack(item);
        };

        // Definiamo il setter per questo elemento
        $("#" + elementId).data('autocomplete-setter', async function(value: string) {
            // Impostiamo il valore nell'input
            $("#" + elementId).val(value);

            // Effettuiamo la richiesta
            const data = await fetchAutocompleteData(url, value);

            // Se abbiamo trovato un risultato esatto, chiamiamo la funzione onSelectItem
            const exactMatch = data.find((item: any) => item.Comune === value);
            if (exactMatch) {
                onSelectItem(exactMatch);
                return exactMatch;
            }

            // Se non abbiamo trovato corrispondenze esatte
            resetFields();
            return null;
        });

        let options: Partial<Config> = {
            suggestionsThreshold: 2,
            autoselectFirst: true,
            ignoreEnter: true,
            tabSelect: true,
            highlightTyped: true,
            highlightClass: "text-primary",
            labelField: "Comune",
            valueField: "IdComune",
            searchFields: ["Comune"],
            queryParam: "search",
            server: url,
            liveServer:true,
            debounceTime: 300,
            onSelectItem: onSelectItem,
        }

        Autocomplete.init("#" + elementId, options);

        // Gestione blur: se l'utente esce dal campo senza selezionare dal menu,
        // ma ha scritto esattamente il nome di un comune, compiliamo i campi
        $("#" + elementId).on("blur", async function () {
            const currentValue = ($(this).val() as string || "").trim();
            if (!currentValue) return;

            // Se l'hidden è già valorizzato (comune già selezionato correttamente), non fare nulla
            const currentHidden = ($("#" + hiddenElementId).val() as string || "").trim();
            if (currentHidden) return;

            // Cerca una corrispondenza esatta (case-insensitive)
            const data = await fetchAutocompleteData(url, currentValue);
            const exactMatch = data.find(
                (item: any) => item.Comune.toLowerCase() === currentValue.toLowerCase()
            );
            if (exactMatch) {
                // Sovrascrive il campo visibile con il nome corretto (casing del DB)
                $("#" + elementId).val(exactMatch.Comune);
                onSelectItem(exactMatch);
            } else {
                resetFields();
            }
        });
 
        /*
        let options_old: any = {
            adjustWidth: false,
            url: function (searchText: string) {
                return url + searchText;
            },
            getValue: "Comune",
            placeholder: placeholder,
            minCharNumber: 2,
            list: {
                onLoadEvent: function () {
                    $("#" + hiddenElementId).val("");
                    if (provinciaElementId != undefined)
                        $("#" + provinciaElementId).val("");
                    if (provinciaTextElementId != undefined)
                        $("#" + provinciaTextElementId).val("");
                    if (capElementId != undefined)
                        $("#" + capElementId).val("");
                    if (CallBack != undefined)
                        CallBack();
                },
                onSelectItemEvent: function () {
                    //console.log($("#" + elementId).getSelectedItemData());
    
    
                },
                onClickEvent: function () {
                    let $element = $("#" + elementId);
                    let id = $element.getSelectedItemData().IdComune;
                    let idprov = $element.getSelectedItemData().IdProvincia;
                    let cap = $element.getSelectedItemData().Cap;
                    let provincia = $element.getSelectedItemData().Provincia;
                    if (hiddenElementId != undefined)
                        $("#" + hiddenElementId).val(id);
                    if (provinciaElementId != undefined)
                        $("#" + provinciaElementId).val(idprov);
                    if (capElementId != undefined)
                        $("#" + capElementId).val(cap);
                    if (provinciaTextElementId != undefined)
                        $("#" + provinciaTextElementId).val(provincia);
                    if (SelectCallBack != undefined)
                        SelectCallBack();
                },
                onChooseEvent: function () {
                    let $element = $("#" + elementId);
                    
                    let id = $element.getSelectedItemData().IdComune;
                    let idprov = $element.getSelectedItemData().IdProvincia;
                    let cap = $element.getSelectedItemData().Cap;
                    let provincia = $element.getSelectedItemData().Provincia;
                    if (hiddenElementId != undefined)
                        $("#" + hiddenElementId).val(id);
                    if (provinciaElementId != undefined)
                        $("#" + provinciaElementId).val(idprov);
                    if (capElementId != undefined)
                        $("#" + capElementId).val(cap);
                    if (provinciaTextElementId != undefined)
                        $("#" + provinciaTextElementId).val(provincia);
                    if (SelectCallBack != undefined)
                        SelectCallBack();
                },
                onHideListEvent: function () {
                    //console.log("hide list");
    
                },
                match: {
                    enabled: true
                },
                maxNumberOfElements: 8
            },
            theme: "square"
        };*/
        //$("#" + elementId).easyAutocomplete(options);
    }

export const autocompleteStati = (
    elementId: string,
    hiddenElementId: string,
    placeholder: string,
    CallBack?:() => void)=>  {
    let options = {
        adjustWidth: false,
        url: function (searchText: string) {
            return window.BaseUrlWebApi + "Istat/GetStato?search=" + searchText
        },
        getValue: "Text",
        placeholder: placeholder,
        minCharNumber: 3,
        list: {
            onLoadEvent: function () {
                $("#" + hiddenElementId).val("");
                if (CallBack != undefined)
                    CallBack();
            },
            onSelectItemEvent: function () {

            },
            onHideListEvent: function () {
                //console.log("hide list");

            },
            onChooseEvent: function () {
                let id = $("#" + elementId).getSelectedItemData().Id;
                $("#" + hiddenElementId).val(id);
                if (CallBack != undefined)
                    CallBack();
            },
            onClickEvent: function () {
                let id = $("#" + elementId).getSelectedItemData().Id;
                $("#" + hiddenElementId).val(id);
                if (CallBack != undefined)
                    CallBack();
            },
            match: {
                enabled: true
            },
            maxNumberOfElements: 8
        },
        theme: "square"
    };
    $("#" + elementId).easyAutocomplete(options);
}
